import { Searchable } from '@/services/searchEngine/fuzzySearch/Searchable';
import { Utils } from '@/services/utils/BasicUtils';
import { Address } from '@/modules/multiForm/shared/MultiformModels';
import { UserBusinessHoursElement } from '@/models/UserBusinessHoursElement';
import { BranchType } from '@/modules/branches/enums/BranchType';
import { IMultiformDictionaryElement } from '@/modules/multiForm/shared/IMultiformDictionary';
import { UserListElement } from '@/models/ppl/UserListElement';
import { LandOfWork, LandOfWorkDto } from '@/models/LandOfWork';

export const NO_BRANCH_INDEX = -1;

export abstract class BranchListElementDto {
  id!: number;
  name!: string;
  type!: BranchType;
  active!: boolean;
}

export class BranchTypeModel implements IMultiformDictionaryElement<BranchType> {
  type!: BranchType;
  name_pl!: string;
}

export default class BranchListElement extends BranchListElementDto implements Searchable {
  public get textToSearch(): string {
    return this.name;
  }

  public get displayName(): string {
    return this.name;
  }

  public get branchTypeShortened(): string {
    switch (this.type) {
      case BranchType.FRANCHISE:
        return '[FR]';
      case BranchType.CERTIFIED:
        return '[CERT]';
      default:
        return '[OW]';
    }
  }

  constructor(branchListElementDto?: BranchListElementDto) {
    super();
    Utils.assign(this, branchListElementDto);
  }
}

export class CreateBranchModel {
  public name: Nullable<string> = null;
  public address: Address = new Address();
  public active: boolean = false;
  public branchType: BranchType = BranchType.FRANCHISE;
  public agentIds: number[] = [];
  public agents: UserListElement[] = [];
  public businessProfileUrl: Nullable<string> = null;
}

export abstract class BranchDto extends CreateBranchModel {
  id!: number;
  name!: string;
  address!: Address;
  branchType!: BranchType;
  hours!: Array<UserBusinessHoursElement>;
  landsOfWork: Array<LandOfWork> = [];
  active!: boolean;
}

export class Branch extends BranchDto {
  constructor(branch?: BranchDto) {
    super();
    this.agentIds = (branch?.agents ?? []).map(x => x.id);
    if (branch) {
      branch.agents = branch.agents.map(x => new UserListElement(x));
      Utils.assign(this, branch);
    }
  }
}

export interface BranchLandsDto {
  branchId: number,
  lands: Array<LandOfWorkDto>,
}
